import React, { useState } from 'react'
import TitleNoteCommon from '../home/generate/TitleNoteCommon'
import { FormGroup, Input, Label } from 'reactstrap';
import Select from 'react-select'
import { Controller } from 'react-hook-form'
import { listChatGpt, interactionLanguages, interactionMethods, listVoiceEngage } from '@utils/dataDefault'
import { BookListFile } from '../home/generate'
import { Icon } from '@components/common'
import { UploadComponent } from '../ReferenceMedia/ModalMedia/UploadCustom';
import ImageUser from '@images/common/no-avatar.jpg';
import styled from 'styled-components';
import ModalSelectCharacter from './ModalSelectCharacter';
import { ButtonComponent } from "@components/patterns/elements/Button";

// const WrapImage = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 16px;
//   .wrap-img {
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//     gap: 6px;
//     img {
//       width: 100%;
//       height: 200px;
//       object-fit: contain;
//     }
//   }
//   .wrap-upload {
//     width: 100%;
//     display: flex;
//     flex-direction: column;
//     gap: 6px;
//     .text-note {
//       font-size: 14px;
//     }
//   }
// `

const WrapCharacter = styled.div`
  width: 100%;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  padding: 16px 24px;
`

const ItemImage = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  .ava__item {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    color: #081B2A;
    &-img {
      width: 147px;
      height: 147px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &-name {
      font-weight: 700;
      font-size: 16px;
      line-height: 20px;
    }
    &-gender {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
  }
`

export default function FormCommon(props) {
  const { setValue, control, watch, bookId, setBookId, showModalBooks, setShowModalBooks } = props
  const [dataFileImported, setDataFileImported] = useState(null);
  const [modal, setModal] = useState({
    uploadImage: false,
  });

  const toggle = (type) => {
    setModal(prevState => ({ ...prevState, [type]: !prevState[type] }));
  };
  
  const TypeUploadFile = (key) => {
    switch (key) {
      case 'Text':
        return (
          <div className='input-form'>
            <TitleNoteCommon title="Profile Image" required />
            <UploadComponent
              dataFileImported={dataFileImported}
              setDataFileImported={setDataFileImported}
              typeUpload="SVG, PNG, JPG or GIF (max. 800x400px)"
              typeFile={["image/png", "image/jpeg"]}
              errorFile="Only JPG/JPEG, PNG files are allowed."
            />
          </div>
        )
      case 'Voice':
        return (
          <>
            <div className='input-form flex-grow-1 mr-2'>
              <TitleNoteCommon title="Voice" />
              <Controller
                control={control}
                name="voice"
                defaultValue={listVoiceEngage?.[0]?.value}
                render={({ field: { onChange } }) => (
                  <Select
                    className="react-select-common w-100"
                    placeholder="Select a voice"
                    value={listVoiceEngage?.find((c) => c.value === watch("voice"))}
                    options={listVoiceEngage}
                    onChange={val => {
                      setValue("voice", val.value)
                      onChange(val.value)
                    }}
                    classNamePrefix="react-select-custom"
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                  />
                )}
              />
            </div>
            <div className='input-form'>
              <TitleNoteCommon title="Profile Image" required />
              <UploadComponent
                dataFileImported={dataFileImported}
                setDataFileImported={setDataFileImported}
                typeUpload="SVG, PNG, JPG or GIF (max. 800x400px)"
                typeFile={["image/png", "image/jpeg"]}
                errorFile="Only JPG/JPEG, PNG files are allowed."
              />
            </div>
          </>
        )
      case 'Avatar':
        return (
          <div className='input-form'>
            <TitleNoteCommon title="Avatar image" required />
            <WrapCharacter>
              <ItemImage>
                <div className="ava__item">
                  <div className="ava__item-img">
                    <img src={watch('img_url') || ImageUser} alt="img" />
                  </div>
                  <p className="ava__item-name">Kumiko</p>
                  <p className="ava__item-gender">42 years old / Female</p>
                </div>
                <div>
                  <ButtonComponent size="small" color="outline" onClick={() => toggle('uploadImage')}>Switch Character</ButtonComponent>
                </div>
              </ItemImage>
              {modal.uploadImage && (
                <ModalSelectCharacter
                  isOpen={modal.uploadImage}
                  toggle={() => toggle("uploadImage")}
                  actions={modal}
                  {...props}
                />
              )}
            </WrapCharacter>
          </div>
        )
      default:
        return <></>
    }
  }
  
  return (
    <div className="formEngage__form-input">
      <div className='input-form'>
        <TitleNoteCommon title="Module Name" required />
        <Controller
          name="name"
          control={control}
          render={({ field }) => (
            <Input
              type="text"
              placeholder='Name for the module (example: Childcare Assistant)'
              name='name'
              {...field}
            />
          )}
        />
      </div>
      <div className='input-form'>
        <TitleNoteCommon title="Instructions for Bot" required />
        <Controller
          name="instruction"
          control={control}
          render={({ field }) => (
            <Input
              type='textarea'
              name='instruction'
              placeholder="Detailed instructions for the AI Bot – including the role, tone, language, etc. (example: YOU are a childcare assistant who speaks in gentle tone to engage with a child at the age between 5 and 10 years old)"
              style={{ height: '80px' }}
              {...field}
            />
          )}
        />
      </div>
      <div className='input-form'>
        <TitleNoteCommon title="Opening Statement" required />
        <Controller
          name="statement"
          control={control}
          render={({ field }) => (
            <Input
              type='textarea'
              name='statement'
              placeholder="The first statement that the bot will say to start conversation (example: Hello! How are you today?)"
              style={{ height: '80px' }}
              {...field}
            />
          )}
        />
      </div>
      <div className="d-flex">
        <div className='input-form flex-grow-1 mr-2'>
          <TitleNoteCommon title="LLM Model" />
          <Controller
            control={control}
            name="model"
            defaultValue={listChatGpt?.[0]?.value}
            render={({ field: { onChange } }) => (
              <Select
                className="react-select-common w-100"
                placeholder="Select Model"
                value={listChatGpt?.find((c) => c.value === watch("model"))}
                options={listChatGpt}
                onChange={val => {
                  setValue("model", val.value)
                  onChange(val.value)
                }}
                classNamePrefix="react-select-custom"
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            )}
          />
        </div>
        <div className='input-form flex-grow-1 ml-2'>
          <TitleNoteCommon title="Interaction Language" />
          <Controller
            control={control}
            name="interactionLanguage"
            defaultValue={interactionLanguages?.[0]?.value || "English"}
            render={({ field: { onChange } }) => (
              <Select
                className="react-select-common w-100"
                placeholder="Select a language"
                value={interactionLanguages?.find((c) => c.value === watch("interactionLanguage")) || interactionLanguages?.[0]}
                options={interactionLanguages}
                onChange={val => {
                  setValue("interactionLanguage", val.value)
                  onChange(val.value)
                }}
                classNamePrefix="react-select-custom"
                components={{
                  IndicatorSeparator: () => null,
                }}
              />
            )}
          />
        </div>
      </div>
      <div className='input-form'>
        <TitleNoteCommon title="Interaction Method" />
        <Controller
          control={control}
          name="interactionMethod"
          defaultValue={interactionMethods?.[0]?.value || "Text"}
          render={({ field }) => (
            <div>
              {interactionMethods.map(method => (
                <FormGroup check className='form-common mr-3 mt-1' key={method.value}>
                  <Input
                    className='react-radio-common'
                    type="radio"
                    id={method.value}
                    value={method.value}
                    checked={field.value === method.value}
                    onChange={() => field.onChange(method.value)}
                  />
                  <Label check htmlFor={method.value} style={{ fontWeight: 400 }}>{method.label}</Label>
                </FormGroup>
              ))}
            </div>
          )}
        />
      </div>
      {TypeUploadFile()}
      <div className='input-form'>
        <TitleNoteCommon title="Reference" />
        {bookId?.length > 0 ? (
          <BookListFile
            {...props}
            bookId={bookId}
            setBookId={setBookId}
          />
        ) : (
          <div
            className="wrap-choice__btn d-flex align-items-center justify-content-center w-100"
            onClick={() => setShowModalBooks(!showModalBooks)}
          >
            <Icon src={File} stroke="#0089C2" />
            <span>Choose from Reference Library</span>
          </div>
        )}
      </div>
    </div>
  )
}